'use strict';

module.exports = {
  silentJSONParsing: true,
  forcedJSONParsing: true,
  clarifyTimeoutError: false
};



//////////////////
// WEBPACK FOOTER
// ./~/sendbird/~/axios/lib/defaults/transitional.js
// module id = 564
// module chunks = 42